import { create } from 'zustand';
import _cloneDeep from 'lodash/cloneDeep';
import { BaseRequestContact, StandardRequestContact } from '@src/api/services/request/types';

type ContactsTableNames = 'adjoiningPropOwners' | 'agents' | 'propOwners';

interface ContactsTableStoreValues {
  adjoiningPropOwners: BaseRequestContact[];
  agents: StandardRequestContact[];
  propOwners: StandardRequestContact[];
}

interface ContactsTableState extends ContactsTableStoreValues {
  resetContactsTables: () => void;
  saveContactsTable: (tableName: ContactsTableNames, data: BaseRequestContact[] | StandardRequestContact[]) => void;
}

const defaults: ContactsTableStoreValues = {
  adjoiningPropOwners: [],
  agents: [],
  propOwners: [],
};

export const useContactsTable = create<ContactsTableState>((set) => ({
  ..._cloneDeep(defaults),
  resetContactsTables: () => set(_cloneDeep(defaults)),
  saveContactsTable: (tableName: ContactsTableNames, data: BaseRequestContact[] | StandardRequestContact[]) =>
    set({ [tableName]: data }),
}));
